import React from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { LockIcon } from "../icons/LockIcon";

const TOOLTIP_WIDTH = 232;

export default function LockFeatureComponent({ className = "", text }) {
  const navigate = useNavigate();
  const [visible, setVisible] = React.useState(false);
  const [coords, setCoords] = React.useState({ top: 0, left: 0 });
  const anchorRef = React.useRef(null);
  const closeTimer = React.useRef(null);

  const open = () => {
    clearTimeout(closeTimer.current);
    setVisible(true);
  };
  const close = () => {
    closeTimer.current = setTimeout(() => setVisible(false), 120);
  };

  const updateCoords = () => {
    if (!anchorRef.current) return;
    const rect = anchorRef.current.getBoundingClientRect();
    const vw = window.innerWidth;
    let left = rect.left + rect.width / 2 - TOOLTIP_WIDTH / 2;
    left = Math.max(8, Math.min(left, vw - TOOLTIP_WIDTH - 8));
    setCoords({ top: rect.top - 8, left });
  };

  React.useLayoutEffect(() => {
    if (!visible) return;
    updateCoords();
    window.addEventListener("scroll", updateCoords, true);
    window.addEventListener("resize", updateCoords);
    return () => {
      window.removeEventListener("scroll", updateCoords, true);
      window.removeEventListener("resize", updateCoords);
    };
  }, [visible]);

  const content = text ?? (
    <>
      Nâng cấp gói Hội viên để mở khóa tính năng{" "}
      <span
        onClick={() => navigate("/pricing")}
        className="font-medium text-[#111827] hover:underline cursor-pointer"
      >
        tại đây
      </span>
      !
    </>
  );

  return (
    <span
      ref={anchorRef}
      className={`relative inline-flex items-center ${className}`}
      onMouseEnter={open}
      onMouseLeave={close}
      onClick={open}
    >
      <span className="cursor-pointer inline-flex">
        <LockIcon />
      </span>
      {visible &&
        createPortal(
          <div
            style={{
              position: "fixed",
              top: coords.top,
              left: coords.left,
              width: TOOLTIP_WIDTH,
              zIndex: 9999,
              transform: "translateY(-100%)",
            }}
            onMouseEnter={open}
            onMouseLeave={close}
            className="rounded-[12px] bg-white px-[16px] py-[12px] text-[14px] leading-[20px] text-[#636369] shadow-[0px_0px_10px_0px_#0000001A] border border-[#ECECED] !font-[400]"
          >
            {content}
          </div>,
          document.body,
        )}
    </span>
  );
}
